import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Dropdown } from 'primereact/dropdown'

import { selectedTpChanged } from '../../store/actions/system.actions'
import { getTps } from '../../services/localstorage/localstorage.service'

class SelectTps extends Component {
  state = {
    tps: [],
    selectedTp: '',
  }
  // Events
  onValueChanged = value => {
    this.setState({ selectedTp: value })
    this.props.dispatch(selectedTpChanged(value))
  }

  // LifeCycle
  componentDidMount = () => {
    const tps = this._parseItems(getTps())
    if (tps && tps.length > 1) {
      this.setState({ tps, selectedTp: 0 })
      this.props.dispatch(selectedTpChanged(0))
    } else if (tps && tps.length === 1) {
      this.setState({ tps, selectedTp: tps[0].value })
      this.props.dispatch(selectedTpChanged(tps[0].value))
    }
  }

  // Render
  render() {
    const { tps, selectedTp } = this.state
    return tps.length === 0 ? null : (
      <Dropdown
        value={selectedTp}
        options={tps}
        onChange={e => this.onValueChanged(e.value)}
        placeholder="Operador Logístico"
        filter
      />
    )
  }

  // Private
  _parseItems(tps) {
    return tps.map(tp => {
      return {
        label: tp.name,
        value: tp.id,
      }
    })
  }
}

export default connect()(SelectTps)
